import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import isString from 'lodash/isString';

import type { DateRange } from '@packages/fenrir/components';

const toNullableDayJs = (value: unknown) =>
  isString(value) ? dayjs(value) : null;

const toUndefinedDateString = (value: Dayjs | null) =>
  value ? value.format('YYYY-MM-DD') : undefined;

const transformInput = (value: unknown): DateRange<Dayjs> =>
  Array.isArray(value) && value.length === 2
    ? [toNullableDayJs(value[0]), toNullableDayJs(value[1])]
    : [null, null];

const transformOutput = (
  v: DateRange<Dayjs>,
): [string | undefined, string | undefined] => [
  toUndefinedDateString(v[0]),
  toUndefinedDateString(v[1]),
];

export const transform = {
  input: transformInput,
  output: transformOutput,
};
